import { Instagram, Linkedin, MapPin, Mail, Phone } from "lucide-react";

const Footer = () => {
  return (
    <div className="w-full bg-black-main-dark text-gray-300">
      <footer className="px-6 md:px-16 py-20 max-w-screen-2xl mx-auto">
        {/* ========== TOP: BRAND + PARTNERS ========== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
          {/* Brand Block */}
          <div>
            <img
              src={process.env.REACT_APP_FOOTER_LOGO}
              alt="TradeTact"
              className="max-h-18 max-w-[260px] object-contain mb-6"
            />

            <p className="text-sm text-gray-400 leading-relaxed max-w-md">
              TradeTact Capital Solutions helps individuals and families invest
              with discipline, clarity, and a long-term perspective without
              tips, speculation, or shortcuts.
            </p>

            {/* Optional Socials */}
            <div className="flex items-center gap-4 mt-6">
              <a
                className="text-gray-400 hover:text-green-400 transition"
                href="https://www.instagram.com/tradetact_official/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={18} />
              </a>
              <a className="text-gray-400 hover:text-green-400 transition">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Partners Section */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-6">
              Our Trusted Partners
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 items-center">
              <img
                src={require("../assets/images/logo_sharekhan.png")}
                alt="Mirae Asset Sharekhan"
                className="max-h-10 max-w-[160px] object-contain opacity-90"
              />

              {/* <img
                src={require("../assets/images/logo_sharekhan.png")}
                alt="Partner 2"
                className="max-h-10 max-w-[160px] object-contain opacity-90"
              />

              <img
                src={require("../assets/images/logo_sharekhan.png")}
                alt="Partner 3"
                className="max-h-10 max-w-[160px] object-contain opacity-90"
              /> */}
            </div>

            <p className="mt-6 text-xs text-gray-400 leading-relaxed max-w-md">
              Authorized Business Partner & Distributor for regulated financial
              products and services.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 mb-14" />

        {/* ========== MIDDLE: REGULATORY + LEGAL ========== */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-xs text-gray-400 leading-relaxed">
          {/* Regulatory Info */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-3">
              Regulatory Information
            </h4>
            <p>
              SEBI Reg. No: INZ000171337 – NSE Cash/CD <br />
              RN: AP2069581501 <br />
              AMFI ARN: 328483 <br />
              GSTIN: 24CZBPG3048N1ZC
            </p>

            <p className="mt-4">
              <span className="font-semibold text-gray-300">
                Registered Office:
              </span>{" "}
              715, 7th Floor, H Block, Swagat Twin City High Street, Gandhinagar
              Bypass Rd, Sargasan, Gandhinagar, Gujarat – 382421.
            </p>
          </div>

          {/* Disclosures */}
          <div className="space-y-4">
            <div>
              <h4 className="font-semibold text-gray-300 mb-1">
                About Mirae Asset Sharekhan
              </h4>
              <p>
                Founded in 2000, Mirae Asset Sharekhan is one of India’s leading
                full-service stockbrokers, serving 31 lakh+ customers across
                1,100+ cities.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-300 mb-1">
                Attention Investors
              </h4>
              <p>
                Beware of unsolicited messages offering tips or guarantees.
                Invest only based on informed decisions and proper analysis.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-300 mb-1">Disclaimer</h4>
              <p>
                Investments in securities and mutual funds are subject to market
                risks. Past performance is not indicative of future results.
              </p>
            </div>
          </div>
        </div>

        {/* ========== BOTTOM ========== */}
        <div className="border-t border-gray-800 mt-16 pt-6 text-center text-xs text-gray-500">
          © {new Date().getFullYear()} TradeTact Capital Solutions. All rights
          reserved.
        </div>
      </footer>
    </div>
  );
};

export default Footer;
